import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

export const FreeFuncList = [
    "档案查看",
    "档案编辑",
    "奖惩查看",
    "奖惩管理",
    "预产期登记查看",
    "预产期登记管理",
    "人事变动查看",
    "人事变动管理",
    "大科片区设置",
    "人员类别设置",
    "护理人员字段设置",
    "护理人员科室设置",
    "角色权限设置",
];

export const PaidFuncList = [
    "档案导出",
    "邀请填写个人档案",
    "档案审批(一级)",
    "档案审批(二级)",
    "执业护士证管理",
    "人员信息查询",
    "人员轮转查看",
    "人员轮转录入",
    "人员轮转评价",
    "人员借调查看",
    "人员借调编辑",
    "人员借调申请",
    "人员借调审批",
    "借调评价",
    "统计查询",
    "考核培训",
    "人员借调设置",
    "档案审批流程设置",
];


const initState = {
    checkedGood: null,
};


const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
